import React from "react";
import { useConfigData } from "../hooks/useConfigData";

const FlagComponent = (
  i18n,
  _i18n_item_prefix,
  pagePathWithoutLocale,
  flag
) => {
  const isLinkToMainLanguage = _i18n_item_prefix === i18n.i18n_main;
  const url4Language = generateUrl4Language(
    _i18n_item_prefix,
    isLinkToMainLanguage,
    pagePathWithoutLocale
  );

  false &&
    console.log(
      "__debug [FlagComponent]🐮🐮🐮🐮" +
        "\n_i18n_item_prefix: " +
        _i18n_item_prefix,
      "\npagePathWithoutLocale: " +
        pagePathWithoutLocale +
        "\nurl4Language: " +
        url4Language +
        "\nisLinkToMainLanguage: " +
        isLinkToMainLanguage +
        "\nurl4Language: " +
        url4Language
    );

  if (!_i18n_item_prefix) return <>🚨</>;

  return <a href={url4Language}>{flag}</a>;
};

const TopbarLanguageIcons = ({ i18n, pagePath }) => {
  const configData = useConfigData();
  const isWebsiteCurrentlyOnMainLanguage = i18n.i18n_current === i18n.i18n_main;

  const pagePathWithoutLocale = isWebsiteCurrentlyOnMainLanguage
    ? pagePath
    : pagePath.substring(3);

  false &&
    console.log(
      "__debug [TopbarLanguageIcons]🐮" +
        "\npagePath: " +
        pagePath +
        "\npagePathWithoutLocale: " +
        pagePathWithoutLocale +
        "\nisWebsiteCurrentlyOnMainLanguage: " +
        isWebsiteCurrentlyOnMainLanguage
    );

  const flags = getFlagComponents(
    i18n,
    isWebsiteCurrentlyOnMainLanguage,
    configData,
    pagePathWithoutLocale
  );

  if (!!configData) {
    return (
      <div id="topbar-language-select" className="paper">
        {flags ?? <></>}
      </div>
    );
  }
  return <></>;
};

export { TopbarLanguageIcons };

/**
 *
 *
 *
 *
 * Helpers
 *
 *
 *
 *
 */
function getFlagComponents(
  i18n,
  isWebsiteCurrentlyOnMainLanguage,
  configData,
  pagePathWithoutLocale
) {
  false &&
    console.log(
      "__debug [getFlagComponents]🐮🐮: " +
        "\nisWebsiteCurrentlyOnMainLanguage: " +
        isWebsiteCurrentlyOnMainLanguage +
        "\npagePathWithoutLocale: " +
        pagePathWithoutLocale
    );

  return i18n.i18n_list.map((_i18n_item_prefix, index) => (
    <div
      key={`single-language-selector-${_i18n_item_prefix}-${index}`}
      id="single-language-selector"
    >
      {FlagComponent(
        i18n,
        _i18n_item_prefix,
        pagePathWithoutLocale,
        configData[`${_i18n_item_prefix}_emoji`]
      )}
    </div>
  ));
}

function old_generateUrl4Language(
  languagePrefix,
  isLinkToMainLanguage,
  pagePathWithoutLocale
) {
  if (isLinkToMainLanguage) {
    return `/${pagePathWithoutLocale}`;
  } else {
    return `/${languagePrefix}${pagePathWithoutLocale}`;
  }
}

/*
// --- ALTERNATIVE: Absolute URL version ---
// This version prepends the domain from process.env.GATSBY_SITE_URL to ensure absolute URLs for all language links.
*/
function generateUrl4Language(
  languagePrefix,
  isLinkToMainLanguage,
  pagePathWithoutLocale
) {
  const siteUrl = (process.env.GATSBY_SITE_URL || "").replace(/\/$/, "");
  let path;
  if (isLinkToMainLanguage) {
    path = `/${pagePathWithoutLocale}`;
  } else {
    path = `/${languagePrefix}${pagePathWithoutLocale}`;
  }
  // Ensure no double slashes
  return siteUrl + path.replace(/\/+/g, "/");
}
